module.exports = __webpack_public_path__ + "static/img/yuque.5236e459.png";